const DEFER_FULL_ONBOARDING_SESSION_KEY = 'deferFullOnboarding';

export const normalizePostAuthRedirect = (path: string | null | undefined): string | null => {
  if (!path?.trim()) {
    return null;
  }

  const trimmed = path.trim();

  return trimmed.startsWith('/') ? trimmed : `/${trimmed}`;
};

export const getStoredPostAuthRedirect = (): string | null =>
  normalizePostAuthRedirect(localStorage.getItem('redirectPath'));

export const activateOnboardingDeferral = (): void => {
  sessionStorage.setItem(DEFER_FULL_ONBOARDING_SESSION_KEY, 'true');
};

export const shouldDeferFullOnboarding = (): boolean => {
  if (sessionStorage.getItem(DEFER_FULL_ONBOARDING_SESSION_KEY) === 'true') {
    return true;
  }

  if (getStoredPostAuthRedirect()) {
    activateOnboardingDeferral();

    return true;
  }

  return false;
};

export const consumePostAuthRedirect = (): string | null => {
  const redirectPath = getStoredPostAuthRedirect();

  if (redirectPath) {
    localStorage.removeItem('redirectPath');
  }

  return redirectPath;
};

/** Full-page navigation — avoids React Router state races during the welcome → target handoff. */
export const navigateToPostAuthRedirect = (fallback?: string | null): boolean => {
  const target = consumePostAuthRedirect() || normalizePostAuthRedirect(fallback);

  if (!target) {
    return false;
  }

  window.location.replace(target);

  return true;
};

export const clearOnboardingDeferral = (): void => {
  sessionStorage.removeItem(DEFER_FULL_ONBOARDING_SESSION_KEY);
};
